import request from '../utils/reques'

export const getHome = (params) => {
  return request({
    url: '/api/index/index',
    method: 'post',
    data:params
  })
}
// 首页搜索
export const homeSearch = (params) => {
  return request({
    url: '/api/index/search',
    method: 'post',
    data:params
  })
}
// 新闻列表
export const getNews = (params) => {
  return request({
    url: '/api/article/index',
    method: 'post',
    data:params
  })
}

// 文章详情
export const getNesDetail = (params) => {
  return request({
    url: '/api/article/detail',
    method: 'post',
    data: params
  })

}

// 文章详情
export const upload = (params) => {
  return request({
    url: '/api/upload/upload',
    method: 'post',
    data: params,
    headers: {
      'Content-type': 'multipart/form-data'
    }
  })
}

// 登录
export const login = (params) => {
  return request({
    url: '/api/user/login',
    method: 'post',
    data: params,
  })
}

// 注册
export const register = (params) => {
  return request({
    url: '/api/user/register',
    method: 'post',
    data: params,
  })
}

// 获取验证码
export const sendCode = (params) => {
  return request({
    url: '/api/user/sendCode',
    method: 'post',
    data: params,
  })
}


// 忘记密码
export const forgetPwd = (params) => {
  return request({
    url: '/api/user/forgetPwd',
    method: 'post',
    data: params,
  })
}

//联系我们提交表单
export const userFeedback = (params) => {
  return request({
    url: '/api/user/feedback',
    method: 'post',
    data: params,
  })
}

//联系我们提交表单
export const getValveDetail = (params) => {
  return request({
    url: '/api/product/detail',
    method: 'post',
    data: params,
  })
}

// 获取下载列表
export const getDownList = (params) => {
  return request({
    url: '/api/product/getDownloadList',
    method: 'post',
    data: params,
  })
}

// 下载文件
export const downloadFile = (params, token) => {
  return request({
    url: '/api/product/download',
    method: 'post',
    data: params,
    headers: {
      'UserToken': token
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js